import type { UniclientCoInsurance } from '@lemonade-hq/uniclient-chat';
import { Flex, Layout, Separator, themeVars } from '@lemonade-hq/uniclient-theme';
import React from 'react';
import * as styles from './CoInsurance.css';

interface CoInsuranceProps {
  readonly coInsurance: UniclientCoInsurance;
  readonly isMobile?: boolean;
}

export const CoInsurance: React.FC<CoInsuranceProps> = ({ coInsurance, isMobile = false }) => {
  const { position, alt, logo, mobileLogo } = coInsurance;

  if (position !== 'top') return null;

  const delimiter = 'delimiter' in coInsurance ? coInsurance.delimiter ?? '|' : '|';
  const logoSrc = isMobile ? mobileLogo : logo;

  if (logoSrc == null) return null;

  return (
    <>
      {delimiter === 'x' ? (
        <Flex
          alignItems="center"
          aria-label="separator"
          as="span"
          className={styles.delimiterText}
          color={themeVars.color.textSecondary}
          justifyContent="center"
        >
          x
        </Flex>
      ) : (
        <Separator className={styles.separator} color="$borderPrimary" decorative orientation="vertical" />
      )}
      <div className={styles.coInsuranceLogoWrapper}>
        <Layout alt={alt} as="img" className={styles.coInsuranceLogo} src={logoSrc} />
      </div>
    </>
  );
};
